require("./src/carousels.js");
require("./src/scrollEvents.js");
require("./src/navigation.js");
require("./src/stats");

